import { toast } from "sonner";
import { baseApi } from "../api/baseApi";
import { EmailBody, EmailData, IMessage } from "../types/communication.types";

// Re-export types for other modules
export { WorkStateEnum } from "../types/work.types";

export const b2bApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCustomerEmailsData: builder.query<EmailData, { CustomerNo: string }>({
      providesTags: ["Emails"],
      query: ({ CustomerNo }) => {
        const url = `/v1/business/mail/GetCustomerEmailsData?customerNo=${CustomerNo}`;
        return {
          url,
        };
      },
    }),
    addEmailToWork: builder.mutation<
      void,
      { email: IMessage; workNo: number; eventDataId?: number; type: string }
    >({
      query: ({ email, workNo, eventDataId, type }) => ({
        url: `/v1/business/mail/AddEmailToWork/${workNo}`,
        method: "POST",
        body: email,
        params: { eventDataId, type },
      }),
      async onQueryStarted({ email }, { queryFulfilled }) {
        try {
          await queryFulfilled;

          toast.success("Aktivitet skapad för " + email.Subject);
        } catch {
          toast.error("Det gick inte skapa aktiviteten, försök igen senare.");
        }
      },
      invalidatesTags: ["Emails"],
    }),
  }),
});

export const { useGetCustomerEmailsDataQuery, useAddEmailToWorkMutation } =
  b2bApi;

// Body renamed to EmailBody to avoid conflicts
export type Body = EmailBody;
